import { defineComponent, inferProps, propsWithDefaults, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import SimpleForm from "./SimpleForm"

interface Props {
	onCancel(): void
	cancelText?: string

	deleteText?: string
	onDelete(): void
}

const ConfirmDeleteForm: ReactiveComponent<Props> = (initialProps, { slots }) => {
	const props = propsWithDefaults(initialProps, {
		cancelText: "Cancel",
		deleteText: "Delete",
	})

	return () => (
		<SimpleForm class="flex flex-col" onSubmit={props.onDelete}>
			{renderSlot(slots)}
			<hr />
			<div class="flex justify-end">
				<div class="flex flex-wrap items-center spacing-3">
					<BootstrapButton color="secondary" type="button" onClick={props.onCancel}>
						{props.cancelText}
					</BootstrapButton>
					<BootstrapButton color="primary" type="submit">
						{props.deleteText}
					</BootstrapButton>
				</div>
			</div>
		</SimpleForm>
	)
}

export default defineComponent(ConfirmDeleteForm, inferProps<Props>())
